<div class="video-recorder-container">
  <video class="video" #videoElem autoplay playsinline></video>
  <div class="timer" *ngIf="htmlVideoRec.isRecording">
    <span class="recording-indicator"></span>
    {{ formatTime(elapsedSeconds) }} / 1:00
  </div>
  <div class="video-recorder-container__btn-wrapper">
    <tidy-button
      [text]="htmlVideoRec.isRecording ? 'Stop Recording' : htmlVideoRec.videoBlob ? 'Retry' : 'Start Recording'"
      [action]="btnAction.bind(this)"
      [class]="htmlVideoRec.videoBlob ? 'secondary rec-btn' : 'primary rec-btn'">
    </tidy-button>

    <tidy-button
      *ngIf="htmlVideoRec.videoBlob"
      text="Save"
      [action]="save.bind(this)"
      [disabled]="!htmlVideoRec.videoBlob || htmlVideoRec.isRecording"
      [class]="htmlVideoRec.videoBlob ? 'primary' : 'secondary'">
    </tidy-button>
  </div>
</div>
